import { defineMessages } from 'react-intl';

export default defineMessages({
  selectAccount: {
    defaultMessage: 'Select Account',
    id: '9vDjB4',
    description: 'Insights > Reports > Account Balance History > Select Account',
  },
});
